export default __webpack_public_path__ + "static/media/login-background.02afe709.png";